import styled from 'styled-components';
import { Row } from 'components/Grid';

export const Container = styled(Row)`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding-top: 32px;
  margin: 0 !important;
  margin-bottom: ${({ $isInsideApp}) => $isInsideApp ? 90 : 0}px !important;
`;

export const LogoContainer = styled.div`
  display: flex;
  flex-direction: column;

`;

export const Back = styled.button`
  background-image: url('/assets/icons/hero/back-icon.svg');
  background-position: center;
  background-repeat: no-repeat;
  background-color: transparent;
  border: none;

  width: 32px;
  height: 32px;
  margin-left: 10px;
`;

export const Logo = styled.img`
  width: 162px;
  margin-left: 8vw;
`;

Logo.xs = styled.img`
  width: 105px;
  margin-left: 15px;
`;

Logo.app = styled.img`
  width: 140px;
  position: absolute;
  bottom: 0;
  transform: translateY(calc(100% + 40px));
`;
